import React, { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { BarChart3, ClipboardCheck, LogOut, RefreshCw } from 'lucide-react';
import { Colonia } from '../../types/colonia';
import { getAvailableAdminPeriods } from './adminData';
import { useAuth } from '../../contexts/AuthContext';
import AdminFloatingMenu from './AdminFloatingMenu';

interface AdminTopbarProps {
  inscricoes: Colonia[];
  selectedYear: string;
  title: string;
  onYearChange: (year: string) => void;
  /** Link público (sem login): esconde navegação/config administrativa (relatórios, troca de
   * ano, atalho de chamada e sair) e não monta o menu Ctrl+' — não é algo pra ficar exposto
   * numa página sem autenticação. */
  publico?: boolean;
  /** Conteúdo extra da página (ex.: seletor de data, indicadores) exibido no header azul,
   * antes dos botões administrativos. */
  children?: React.ReactNode;
}

const AdminTopbar: React.FC<AdminTopbarProps> = ({ inscricoes, selectedYear, title, onYearChange, publico, children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuth();
  const availableYears = useMemo(() => getAvailableAdminPeriods(inscricoes), [inscricoes]);
  const isRelatorios = location.pathname.includes('relatorios');
  const isChamada = location.pathname.includes('chamada-rapida');

  const handleLogout = () => {
    logout();
    navigate('/admin');
  };

  return (
    <>
      {!publico && <AdminFloatingMenu inscricoes={inscricoes} selectedYear={selectedYear} />}
      <header className="legacy-topbar">
        <div className="legacy-logo-wrap">
          <img src="/logo.png" alt="Colonia de Ferias UBA Clube 2026" className="legacy-logo" />
        </div>
        <h1>{title}</h1>
        {(children || !publico) && (
          <div className="legacy-top-actions">
            {children}
            {!publico && (
              <>
                <label className="legacy-year-switch">
                  <span>Ano:</span>
                  <select value={selectedYear} onChange={(event) => onYearChange(event.target.value)}>
                    {(availableYears.length ? availableYears : [selectedYear]).map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                  <RefreshCw size={16} />
                </label>
                <button className={`legacy-top-button nav ${isRelatorios ? 'active' : ''}`} type="button" onClick={() => navigate('/relatorios-colonia')}>
                  <BarChart3 size={15} />
                  Relatorios
                </button>
                <button className={`legacy-top-button nav ${isChamada ? 'active' : ''}`} type="button" onClick={() => navigate('/chamada-rapida')}>
                  <ClipboardCheck size={15} />
                  Chamada Rapida
                </button>
                <button className="legacy-top-button outline" type="button" onClick={handleLogout}>
                  <LogOut size={15} />
                  Sair
                </button>
              </>
            )}
          </div>
        )}
      </header>
    </>
  );
};

export default AdminTopbar;
